export default __webpack_public_path__ + "static/media/sin_stock.0dc2b892.png";